import { Star } from "lucide-react";

import { SkeletonLoader } from "../../../common/SkeletonLoader";

import { JobCard } from "./JobCard";

export function Matched({ jobs, isLoading, onJobUpdated }) {
  return (
    <main className="flex flex-col gap-y-4">
      {isLoading ? (
        // Show 3 skeleton cards while loading
        Array.from({ length: 3 }).map((_, idx) => (
          <SkeletonLoader key={idx} />
        ))
      ) : jobs.length > 0 ? (
        jobs.map((job) => <JobCard key={job.id} job={job} onJobUpdated={onJobUpdated} />)
      ) : (
        <div className="flex items-center justify-center min-h-[250px]">
          <div className="flex flex-col gap-y-4 items-center justify-center text-gray-400 dark:text-gray-500">
            <Star className="size-10" />
            <h2 className="text-md font-medium">
              No jobs found. Matching opportunities shortly!
            </h2>
          </div>
        </div>
      )}
    </main>
  );
}
